// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ZQmM","modalFooterButton":"ModalNotes_modalFooterButton__3akxf"};